import React from 'react'

export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.77541 2.9419C6.66281 2.8247 6.59961 2.6658 6.59961 2.5V0.0180664C7.02471 0.0583464 7.42241 0.254147 7.72221 0.570557L9.09261 2.0449C9.36411 2.3396 9.53501 2.7192 9.57921 3.125H7.19961C7.04051 3.125 6.88791 3.0591 6.77541 2.9419Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.40007 0V2.5C5.40007 2.9973 5.58967 3.4741 5.92717 3.8259C6.26477 4.1775 6.72257 4.375 7.19997 4.375H9.59997V9.375C9.59907 10.2036 9.28267 10.9978 8.72027 11.5835C8.15787 12.1694 7.39537 12.499 6.59997 12.5H2.99997C2.20467 12.499 1.44217 12.1694 0.879761 11.5835C0.317321 10.9978 0.00098 10.2036 0 9.375V3.125C0.00098 2.2964 0.317321 1.5022 0.879761 0.9165C1.44217 0.33057 2.20467 0.00098 2.99997 0H5.40007Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.6 15H9C9.7954 14.999 10.5579 14.6694 11.1203 14.0835C11.6827 13.4978 11.9991 12.7036 12 11.875V5C12 4.916 11.9837 4.8337 11.953 4.7576C11.9232 4.6836 11.8797 4.6157 11.8243 4.5581C11.7118 4.4409 11.5592 4.375 11.4001 4.375C11.2409 4.375 11.0883 4.4409 10.9757 4.5581C10.8633 4.6753 10.8 4.8342 10.8 5V11.875C10.8 12.3723 10.6104 12.8491 10.2728 13.2009C9.9353 13.5525 9.4774 13.75 9 13.75H3.6C3.4409 13.75 3.2883 13.8159 3.1758 13.9331C3.0633 14.0503 3 14.2092 3 14.375C3 14.5408 3.0633 14.6997 3.1758 14.8169C3.2883 14.9341 3.4409 15 3.6 15Z"
      fill="currentColor"
    />
  </svg>
)
